// Google Analytics утиліти
export const GA_TRACKING_ID = 'G-PRV6XRMSBM';

// Ініціалізація Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Відстеження переглядів сторінок
export const trackPageView = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Відстеження подій
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Відстеження користувацьких подій
export const trackCustomEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Відстеження конверсій
export const trackConversion = (conversionId, conversionLabel, value = 0) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${conversionId}/${conversionLabel}`,
      value: value,
      currency: 'UAH'
    });
  }
};

// Встановлення користувацьких параметрів
export const setUserProperties = (properties) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      custom_map: properties
    });
  }
};

// Відстеження часу на сторінці
export const trackTiming = (category, variable, value, label) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'timing_complete', {
      name: variable,
      value: value,
      event_category: category,
      event_label: label
    });
  }
};

// Відстеження помилок
export const trackError = (description, fatal = false) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'exception', {
      description: description,
      fatal: fatal
    });
  }
};

// Специфічні події для кулінарного сайту
export const trackRecipeView = (recipeId, recipeName, category) => {
  trackCustomEvent('recipe_view', {
    recipe_id: recipeId,
    recipe_name: recipeName,
    recipe_category: category
  });
};

export const trackRecipeSearch = (searchTerm, resultsCount) => {
  trackCustomEvent('recipe_search', {
    search_term: searchTerm,
    results_count: resultsCount
  });
};

export const trackUserRegistration = (method) => {
  trackCustomEvent('sign_up', {
    method: method
  });
};

export const trackUserLogin = (method) => {
  trackCustomEvent('login', {
    method: method
  });
};

export const trackRecipeShare = (recipeId, method) => {
  trackCustomEvent('share', {
    content_type: 'recipe',
    content_id: recipeId,
    method: method
  });
};

export const trackRecipeLike = (recipeId) => {
  trackCustomEvent('recipe_like', {
    recipe_id: recipeId
  });
};

export const trackRecipeComment = (recipeId) => {
  trackCustomEvent('recipe_comment', {
    recipe_id: recipeId
  });
};